"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omit = void 0;
/**
 * Возвращает новый объект с ключами из `object` за исключением тех которые указаны в `keys`.
 *
 * @example
 * omit({ f1: 'v1', f2: 'v2' }, ['f1'])
 *
 * @param shape Исходный объект.
 * @param paths Список ключей которые нужно не учитывать.
 */
function omit(shape, paths) {
    var keys = Object.keys(shape);
    var result = {};
    for (var i = 0; i < keys.length; i += 1) {
        var key = keys[i];
        if (paths.indexOf(key) === -1) {
            result[key] = shape[key];
        }
    }
    return result;
}
exports.omit = omit;
